import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface UserSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function UserSearch({ value, onChange, placeholder }: UserSearchProps) {
  const { dir } = useLanguage();

  return (
    <div className="relative flex-1">
      <Search className={`absolute ${dir === 'rtl' ? 'right-3' : 'left-3'} top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground`} />
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={dir === 'rtl' ? 'pr-9' : 'pl-9'}
        dir={dir}
      />
    </div>
  );
}